import { environment } from 'src/environments/environment';

export default class AppSettings {
  public static BASE_URL: string = environment.apiUrl;
  public static APP_VERSION: string = environment.version;
  public static QUERY_RETRY_COUNT = 1;
  public static SESSION_PROLONG_THRESHOLD: number = 15 * 1000; // 15 seconds in milliseconds
  public static FORM_FIELD_ARRAY_VALUE_SEPARATOR = ', ';
  public static FORMAT_DATE_PIPE_DATE_TYPE = 'date';
  public static FORMAT_DATE_PIPE_DATETIME_TYPE = 'datetime';
  public static PAGINATION_BOX_MOBILE_SCREEN_WIDTH = 411;
  public static CHAT_MESSAGES_CHUNK = 10;
  public static DEFAULT_USER_IMAGE = 'assets/images/user.svg';
  public static NO_PHOTO_DEFAULT_IMAGE = '/assets/images/no-photo-profile.svg';
  public static DELETED_USER_IMAGE = '/assets/images/deleted-user-image.png';
  public static USER_ROLE_PREFIX = 'USER_ROLE_HINTS.';

  public static DEFAULT_TOAST_DELAY = 5000; // 5 seconds
  public static FAILURE_TOAST_DELAY = 10000; // 10 seconds

  public static LOCALSTORE_KEY_TOKEN = 'token';
  public static LOCALSTORE_KEY_USERID = 'userId';
  public static LOCALSTORE_KEY_ADMIN_SESSION = 'adminSession';
  public static LOCALSTORE_KEY_SECONDAUTHLVL = 'secondAuthLvl';
  public static LOCALSTORE_KEY_TOKEN_PROLONG_TIME = 'tokenProlongTime';
  public static LOCALSTORE_KEY_CHAT_WITH_USERID = 'chatWithUserID';
  public static LOCALSTORE_KEY_OPEN_DROPDOWN_MESSENGER = 'openDropdown';
  public static LOCALSTORE_KEY_2FA_PREFERRED_CHANNEL = 'secondAuthLvlPreferredChannel';
  public static LOCALSTORE_KEY_REQUEST_OTP_BLOCKED_UNTIL = 'requestOtpBlockedUntil';
}
